module.exports = __webpack_public_path__ + "static/media/flipVertical.6f6d5e5d.svg";